<template>
    <v-dialog v-model="_visible" activator="parent" width="450" class="notification-dialog">
        <notification-dialog-content :model-value="notificationMessages" rounded="lg" @click-close="_visible = false" />
    </v-dialog>
</template>

<script setup lang="ts">
import { NotificationMessageDto } from '@/types/webapi';
import { useVModel } from '@vueuse/core';
import NotificationDialogContent from './NotificationDialogContent.vue';

interface Props {
    modelValue?: boolean;
    notificationMessages: NotificationMessageDto[];
}

const props = defineProps<Props>();
const _visible = useVModel(props, 'modelValue');
</script>

<style lang="scss">
@use 'vuetify/settings' as *;
@use 'sass:map';

.notification-dialog {
    &__title {
        font-size: calc(20px / $font-size-root) * 1rem;
        line-height: calc(30px / 24px);
        font-weight: 700;

        @media #{map.get($display-breakpoints, 'md-and-up')} {
            font-size: calc(24px / $font-size-root) * 1rem;
        }
    }

    &__message {
        font-size: calc(16px / $font-size-root) * 1rem;

        @media #{map.get($display-breakpoints, 'md-and-up')} {
            font-size: calc(18px / $font-size-root) * 1rem;
        }
    }

    &__chip-text {
        font-size: calc(16px / $font-size-root) * 1rem;
    }
}
</style>
